var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourseVirtualClassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.617,
    height: 34.075,
    viewBox: "0 0 45.617 34.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4232",
    "data-name": "Group 4232",
    transform: "translate(-745.809 -783.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4215",
    "data-name": "Group 4215",
    transform: "translate(745.809 783.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M272.451,126.085H230.4a1.359,1.359,0,0,0-1.359,1.359v25.7A1.359,1.359,0,0,0,230.4,154.5h17.337v3.206h-5.2v1.6h17.77v-1.6h-5.2V154.5h17.338a1.359,1.359,0,0,0,1.359-1.359v-25.7A1.359,1.359,0,0,0,272.451,126.085Zm-40.693,25.7V128.8h39.334v22.984Z",
    transform: "translate(-228.618 -125.661)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748_-_Outline",
    "data-name": "Path 5748 - Outline",
    d: "M230.325,125.585h42.05a1.785,1.785,0,0,1,1.783,1.783v25.7a1.785,1.785,0,0,1-1.783,1.783H255.462v2.357h5.2v2.45H242.041v-2.45h5.2v-2.357H230.325a1.785,1.785,0,0,1-1.783-1.783v-25.7A1.785,1.785,0,0,1,230.325,125.585ZM272.376,154a.935.935,0,0,0,.934-.934v-25.7a.935.935,0,0,0-.934-.934h-42.05a.935.935,0,0,0-.934.934v25.7a.935.935,0,0,0,.934.934h17.762v4.055h-5.2v.752h16.921v-.752h-5.2V154Zm-41.117-25.7h40.183v23.833H231.258Zm39.334.849H232.107v22.135h38.485Z",
    transform: "translate(-228.542 -125.585)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1558",
    "data-name": "Line 1558",
    d: "M1.654,23.776H-.5V0H1.654Z",
    transform: "translate(22.154 2.884)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1559",
    "data-name": "Line 1559",
    d: "M19.53,1.659H0V-.5H19.53Z",
    transform: "translate(23.383 14.192)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bxs-user",
    d: "M6.758,5.758A3.758,3.758,0,1,0,10.517,2,3.763,3.763,0,0,0,6.758,5.758ZM17.2,17.868h.835v-.835a5.854,5.854,0,0,0-5.846-5.846H8.846A5.853,5.853,0,0,0,3,17.033v.835H17.2Z",
    transform: "translate(2.454 5.622)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bxs-user-2",
    "data-name": "bxs-user",
    d: "M4.513,3.513A1.513,1.513,0,1,0,6.025,2,1.514,1.514,0,0,0,4.513,3.513Zm4.2,4.874h.336V8.051A2.356,2.356,0,0,0,6.7,5.7H5.353A2.356,2.356,0,0,0,3,8.051v.336H8.714Z",
    transform: "translate(27.123 15.523)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bxs-user-3",
    "data-name": "bxs-user",
    d: "M4.513,3.513A1.513,1.513,0,1,0,6.025,2,1.515,1.515,0,0,0,4.513,3.513Zm4.2,4.874h.336V8.051A2.356,2.356,0,0,0,6.7,5.7H5.353A2.356,2.356,0,0,0,3,8.051v.336H8.715Z",
    transform: "translate(27.123 3.632)",
    fill: "#525252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseVirtualClassroom);
export default __webpack_public_path__ + "static/media/icon_course_virtual_classroom.980bc5eac046322d554fdf0e1f025177.svg";
export { ForwardRef as ReactComponent };